const quickCards = [
  {
    icon: "ri-verified-badge-line",
    color: "text-primary-500",
    title: "正版标识",
    desc: "红色封签式认证角标",
  },
  {
    icon: "ri-wifi-line",
    color: "text-accent-600",
    title: "访问方式",
    desc: "桌面与移动端均适配",
  },
  {
    icon: "ri-shield-star-line",
    color: "text-secondary-600",
    title: "安全提示",
    desc: "谨防来历不明转发链接",
  },
];

export default function Hero() {
  return (
    <section id="top" className="scroll-mt-24 border-b border-background-200">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-stretch">
          {/* 左：杂志封面卡 */}
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative h-72 w-full overflow-hidden md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20featuring%20a%20glowing%20newspaper%20and%20magnifying%20glass%20over%20warm%20amber%20city%20lights%20at%20night%2C%20dramatic%20yet%20elegant%20lighting%2C%20subtle%20film%20grain%2C%20rich%20warm%20neutral%20palette%2C%20premium%20print%20aesthetic&width=900&height=1100&seq=chigualu-hero-cover&orientation=portrait"
                  alt="吃瓜官网 本期官方封面导览"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
                <p className="absolute bottom-3 left-4 text-xs text-background-100 md:text-sm">
                  本期导览 · OFFICIAL ENTRY · 2026.09
                </p>
              </div>
              {/* 认证角贴 */}
              <div className="absolute right-4 top-4 flex flex-col items-center justify-center rounded-full border-2 border-background-100/80 bg-primary-500 px-3 py-2 text-center text-background-50">
                <i className="ri-verified-badge-fill text-lg"></i>
                <span className="mt-0.5 text-[11px] font-medium leading-none">唯一认证</span>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-[11px] tracking-[0.2em] text-secondary-500">CHIGUAN OFFICIAL PORTAL</p>
                <p className="mt-1.5 font-display text-lg font-bold text-foreground-950">
                  本期专题：如何分辨「正版入口」与「仿冒站点」
                </p>
                <p className="mt-1 text-sm text-foreground-600">从域名、角标到页面气质，四步教你一眼辨真伪。</p>
              </div>
            </div>
          </div>

          {/* 右：头条 + 速览卡 */}
          <div className="flex flex-col lg:col-span-7">
            <p className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600 md:text-sm">
              <span className="h-px w-6 bg-primary-500"></span>
              官方认证入口 · 认准唯一标识
            </p>
            <h1 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-5xl">
              认准<span className="text-primary-500">吃瓜官网</span>
              <br className="hidden md:block" /> 唯一官方认证地址
            </h1>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              从本站进入的始终是<b>吃瓜官网正版入口</b>。页面右上角的红色封签式认证角标，是区分官方站点与仿冒站点的唯一凭证，请务必先核验再浏览。
            </p>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a
                href="#guide"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-arrow-right-up-line"></i>
                直达官方地址
              </a>
              <a
                href="#fake"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-800"
              >
                防伪识别指南
              </a>
            </div>

            {/* 速览三卡 */}
            <div className="mt-8 grid gap-3 sm:grid-cols-3">
              {quickCards.map((card) => (
                <div
                  key={card.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-3.5 md:p-4"
                >
                  <span className={"flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-lg " + card.color}>
                    <i className={card.icon}></i>
                  </span>
                  <p className="mt-2.5 text-sm font-semibold text-foreground-950">{card.title}</p>
                  <p className="mt-0.5 text-xs text-foreground-600">{card.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}